import { ReactNode } from 'react';
import cn from 'classnames';
import css from './LayoutConfines.module.scss';

interface IProps {
  children: ReactNode;
  extra?: boolean;
  className?: string;
}

export default function LayoutConfines({
  children,
  extra = false,
  className,
}: IProps) {
  return (
    <div className={cn(css.wrapper, extra && css.extra, className)}>
      {children}
    </div>
  );
}
